import { useNavigate, Link } from "react-router-dom";

export default function BackgroundCheck() {
    return (
        <main className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
            <h1 className="text-3xl font-bold text-gray-900">Background Check Portal</h1>
            <p className="mt-4 text-gray-700">
                The Background Check Portal is a secure web-based intake and case management system designed
                for agencies and enterprises conducting pre-employment and licensing checks.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-gray-900">Key Features</h2>
            <ul className="mt-3 list-disc pl-6 text-gray-700 space-y-2">
                <li>Secure applicant enrollment with photo upload.</li>
                <li>Electronic consent form capture with ePad signature device support.</li>
                <li>Fingerprint record status tracking and FDLE/FBI workflow integration.</li>
                <li>Role-based access, full audit trail, and reporting.</li>
                <li>Export of results in CSV/XML for HR or agency systems.</li>
            </ul>

            <h2 className="mt-8 text-xl font-semibold text-gray-900">Integration</h2>
            <p className="mt-3 text-gray-700">
                Designed to integrate with DactylScan Live Scan for fingerprint capture and with ExamsPro
                for candidate testing, offering a complete identity lifecycle solution.
            </p>
            {/* Back to Home link (same style as Login.tsx) */}
            <p className="mt-6 text-center text-sm text-gray-600">
                <Link to="/" className="text-indigo-600 hover:underline">
                    ← Back to Home
                </Link>
            </p>
        </main>
    );
}
